module.exports = __webpack_public_path__ + "static/img/ent-35.1a2a9a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-35.jpg
// module id = NrQe
// module chunks = 52